<template>
  <div>
    <role-form
            @reload-list="reload"
            @closeSidebar="toggleDataSidebar"
            :isSidebarActive="addNewDataSidebar"
            :title="formTitle"
            :operation="operation"
            :data="sidebarData"
            v-if="addNewDataSidebar"
    ></role-form>
    <dialog-delete-item  title="Deseja excluir o Perfil?" @closeDialogData="dialogData"    @reload-list="reload" :loadDialog="loadDialog" :mutation="deleteItem" :dataID="dataID">
    </dialog-delete-item>
    <v-card>
      <div >
        <v-data-table
                :search="search"
                dense
                @page-count="pageCount = $event"
                :page.sync="page"
                :headers="headers"
                :items="rowData"
                :header-props="headerProps"
                mobile-breakpoint="900"
                :footer-props="{
                  showFirstLastPage: false,
                     'items-per-page-text':'linhas por página',
                     itemsPerPageOptions:[5,10,20,30,40,50]
                  }"
                sort-by="calories"
                class="border elevation-1"
                no-data-text="Nenhum registro disponível"
                no-results-text="Nenhum registro encontrado"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-text-field
                      full-width
                      class="mr-3"
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Busca"
                      outlined
                      dense
                      single-line
                      hide-details
              ></v-text-field>
              <v-btn
                      color="primary"
                      v-if="permissions.create"
                      @click="addNewData()"
                      dark
              ><span class="text-md-subtitle-2">Novo</span></v-btn>
            </v-toolbar>
          </template>
          <template v-slot:item.actions="{ item }">
            <role-actions
                    @edit-data="openSideBarEdit"
                    @delete-data="openConfirm"
                    :areaAccess="accessedArea"
                    :permissions.sync="permissions"
                    :item="item"
            ></role-actions>
          </template>
          <template v-if="rowData.length != 0" v-slot:footer.page-text="props">
            {{props.pageStart}} - {{props.pageStop}} de {{props.itemsLength}}
          </template>
        </v-data-table>

<!--        <div class="text-center pt-2">-->
        <!--          <v-pagination class="custom" v-model="page" btn="btn" :length="pageCount"></v-pagination>-->
        <!--        </div>-->
      </div>
    </v-card>
  </div>
</template>

<script>

    import checkPermissionsMixin from '@/mixins/check-permissions'
    import DialogDeleteItem from "@/components/appComponents/DialogDeleteItem"
    import { DeleteMutation } from '@/graphql/mutations/Role.gql'
    import RoleForm from './RoleForm'
    import RoleActions from "./RoleActions"

    export default {
        name: "RoleList",
        components: {
            RoleForm,
            RoleActions,
         DialogDeleteItem
        },
        mixins: [checkPermissionsMixin],
        data: () => {
            return {
                accessedArea: 'roles',
                addNewDataSidebar: false,
                operation: "",
                loadDialog: false,
                sidebarData: {},
                dataID: null,
                deleteItem:null,
                headerProps: {
                    sortByText: "buscar por"
                },
                search: "",
                page: 1,
                pageCount: 0,
                formTitle: "Novo Perfil",
                editedItem: {},
                headers: [
                    { text: "Nome", align: "left", value: "name" },
                    { text: "Alias", align: "left", value: "alias" },
                    { text: "Descrição", align: "left", value: "description" },
                    { text: "Ações", value: "actions", sortable: false },
                ],
                permissions: {
                    create: true,
                    update: true,
                    delete: true,
                    read:true


                },
                rowData: [],
            }
        },
        apollo: {
            rowData: {
                query: require('@/graphql/queries/Role.gql').getRoles,
                update: data => data.roles
            }
        },
        methods: {
            toggleDataSidebar(val = false) {
                this.addNewDataSidebar = val
            },
           dialogData(val = false) {
            this.loadDialog = val
           },
            addNewData() {
                this.sidebarData = {}
                this.operation = "create"
                this.toggleDataSidebar(true)
            },
            async openSideBarEdit(dataID) {
                await this.$apollo
                    .query({
                        query: require('@/graphql/queries/Role.gql').getRole,
                        variables: {
                            id: dataID
                        }
                    })
                    .then(({ data: { role } }) => {
                        this.sidebarData = role
                        this.operation = "update"
                        this.formTitle = "Atualizar Perfil"
                    })
                    .catch((error) => {
                        console.error(error)
                    })
                this.toggleDataSidebar(true)
            },
           openConfirm(deleteID) {
            this.dataID = deleteID
            this.deleteItem = DeleteMutation
            this.dialogData(true)
           },
            reload() {
                this.$apollo.queries.rowData.refetch()
            },
        },
    }
</script>
<style>
  .custom  .v-pagination__item{
    width: 1px;
    height: 30px;
  }
</style>